import { useState, useEffect } from 'react';

export function useActiveHeading(ids: string[]): string {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    if (ids.length === 0) return;

    const intersecting = new Set<string>();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            intersecting.add(entry.target.id);
          } else {
            intersecting.delete(entry.target.id);
          }
        });

        const first = ids.find((id) => intersecting.has(id));
        if (first !== undefined) {
          setActiveId(first);
        }
      },
      {
        rootMargin: '0px 0px -60% 0px',
        threshold: 0,
      },
    );

    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => {
      observer.disconnect();
      intersecting.clear();
    };
  }, [ids]);

  return activeId;
}
